module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "param-table"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.parameters,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "配置项",
      "header-align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "popper-class": "form-tooltip",
            "placement": "bottom"
          }
        }, [_c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [(scope.row.description) ? _c('span', [_vm._v(_vm._s(scope.row.description))]) : _c('span', [_vm._v("暂无描述")])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.key))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "值",
      "header-align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          model: {
            value: (scope.row.value),
            callback: function($$v) {
              _vm.$set(scope.row, "value", $$v)
            },
            expression: "scope.row.value"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "header-align": "left",
      "width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.handleSubmit(scope.row)
            }
          }
        }, [_vm._v("更新")])]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c0eb8d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/system_config_manage/config_input.vue
// module id = 1393
// module chunks = 1